module.exports = __webpack_public_path__ + "static/img/2270_phase_function_Paper_PointsHejduk_Prediction.4ae210d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2270_phase_function_Paper_PointsHejduk_Prediction.png
// module id = jz1c
// module chunks = 0